

















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Image as vanImage, Lazyload } from "vant";
import { VideoNewsItem } from "@/api/types";
Vue.use(Lazyload, {
  lazyComponent: true
});

@Component({
  components: {
    vanImage
  }
})
export default class newsItem extends Vue {
  @Prop()
  newsItem!: VideoNewsItem;
  isplay: boolean = true;
  newItemClick() {
    window.open(this.newsItem.url);
  }
  getFirstLabel(str: string) {
    let _str = str.replace(/^,|,$/g, "");
    return _str.split(",")[0];
  }
}
